import {
    GET_CAREERS_STATED,
    GET_CAREERS,
    GET_CAREERS_ENDED,
    ADD_CAREER_STATED,
    ADD_CAREER,
    ADD_CAREER_ENDED,
    EDIT_CAREER_STATED,
    EDIT_CAREER,
    EDIT_CAREER_ENDED,
    GET_CAREER_STATED,
    GET_CAREER,
    GET_CAREER_ENDED,
    GET_ALL_CAREERS_STATED,
    GET_ALL_CAREERS,
    GET_ALL_CAREERS_ENDED
} from "../types/career_type";

const initialState = {
    careers_loading: true,
    careers: null,
    page: null,
    pages: null,
    total_careers: 0,

    career: null,
    career_loading: null,

    loading: true,

    career_message: null,
    all_careers: null,
    all_careers_loading: null,
    add_career_loading: true,
    edit_career_loading: true
};

export const career_reducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case GET_CAREERS_STATED:
            return {
                ...state,
                careers: null,
                pages: null,
                page: null,
                total_careers: 0,
                careers_loading: true
            };
        case GET_CAREERS:
            return {
                ...state,
                careers: payload.careers,
                pages: payload.pages,
                page: payload.page,
                total_careers: payload.count
            };
        case GET_CAREERS_ENDED:
            return {
                ...state,
                careers_loading: false
            };
        case GET_ALL_CAREERS_STATED:
            return {
                ...state,
                all_careers_loading: true,
                all_careers: null
            };
        case GET_ALL_CAREERS:
            return {
                ...state,
                all_careers: payload
            };
        case GET_ALL_CAREERS_ENDED:
            return {
                ...state,
                all_careers_loading: false
            };

        case ADD_CAREER_STATED:
            return {
                ...state,
                career_message: null,
                add_career_loading: true
            };
        case ADD_CAREER:
            return {
                ...state,
                career_message: payload
            };
        case ADD_CAREER_ENDED:
            return {
                ...state,
                add_career_loading: false
            };
        case GET_CAREER_STATED:
            return {
                ...state,
                career: null,
                career_loading: true
            };
        case GET_CAREER:
            return {
                ...state,
                career: payload
            };
        case GET_CAREER_ENDED:
            return {
                ...state,
                career_loading: false
            };
        case EDIT_CAREER_STATED:
            return {
                ...state,
                career_message: null,
                edit_career_loading: true
            };
        case EDIT_CAREER:
            return {
                ...state,
                career_message: payload
            };
        case EDIT_CAREER_ENDED:
            return {
                ...state,
                edit_career_loading: false
            };

        default:
            return state;
    }
};
